import axios from "../../utils/axios";

export const comfirmation_overview = async (filter_by = "all") => {
    const response = await axios.get(`/admin/dashboard/confirmations?filter_by=${filter_by}`);
    const { data } = response;

    return data;
};

export const statuses_overview = async (period = "all") => {
    const response = await axios.get(`/admin/dashboard/statuses?period=${period}`);
    const { data } = response;

    return data;
};

export const get_payments_overview = async () => {
    const response = await axios.get(`/admin/count_payments`);
    const { data } = response;

    return data;
};

export const get_summary_table = async (selectedMonth) => {
    const response = await axios.get(`/admin/dashboard/summary_table?date=${selectedMonth}`);
    const { data } = response;

    return data;
};

export const search_by_status = async (status, period) => {
    const response = await axios.get(`/admin/search_by_status?status=${status}&period=${period}`);
    const { data } = response;

    return data;
}

export const get_monthly_summary = async (year) => {
    const response = await axios.get(`/admin/dashboard/monthly-summary?year=${year}`);
    const { data } = response;

    return data;
};

// Get sales chart data (daily or monthly aggregation)
export const get_sales_chart_data = async (viewType, year, month, stockId) => {
    let url = `/admin/dashboard/sales-chart?view_type=${viewType}&year=${year}`;
    if (month) url += `&month=${month}`;
    if (stockId) url += `&stock_id=${stockId}`;

    const response = await axios.get(url);
    return response.data;
};

// Get commercial user sales chart data
export const get_commercial_sales_data = async (viewType, year, month, employeeId) => {
    let url = `/admin/dashboard/commercial-sales?view_type=${viewType}&year=${year}&employee_id=${employeeId}`;
    if (month) url += `&month=${month}`;

    const response = await axios.get(url);
    return response.data;
};

// Get client user sales chart data
export const get_client_sales_data = async (viewType, year, month, clientId) => {
    let url = `/admin/dashboard/client-sales?view_type=${viewType}&year=${year}&client_id=${clientId}`;
    if (month) url += `&month=${month}`;

    const response = await axios.get(url);
    return response.data;
};

// Get deliveries for a specific period (for chart click details)
export const get_period_deliveries = async (viewType, year, month, day, employeeId, stockId) => {
    let url = `/admin/dashboard/period-deliveries?view_type=${viewType}&year=${year}&month=${month}`;
    if (day) url += `&day=${day}`;
    if (employeeId) url += `&employee_id=${employeeId}`;
    if (stockId) url += `&stock_id=${stockId}`;

    const response = await axios.get(url);
    return response.data;
};
